import { Buffer } from "buffer";
import axios from "axios";
import bs58 from "bs58";
import { createEmptyLogsAndVars, recordPotentialAxiosError, recordVariable, ReportingError, } from "../diagnostics/clientErrors";
import { baseUrl, apiVersion } from "./config";
export { baseUrl, apiVersion };
export const sendMessageWithNcSignature = async (provider, walletAddress, sendObject) => {
    const logsAndVars = createEmptyLogsAndVars("dwcommonutils:sendMessageWithNcSignature");
    try {
        recordVariable(logsAndVars, "walletAddress (param)", walletAddress);
        recordVariable(logsAndVars, "sendObject (param)", sendObject);
        const method = decideMethodFromSendObject(sendObject);
        recordVariable(logsAndVars, "method", method);
        const expirationTimestamp = generateExpirationTimeStamp();
        recordVariable(logsAndVars, "expirationTimestamp", expirationTimestamp);
        sendObject.expirationTimestamp = expirationTimestamp;
        sendObject.ncWalletAddress = walletAddress;
        const sendString = JSON.stringify(sendObject);
        recordVariable(logsAndVars, "sendString", sendString);
        // console.log(sendString);
        const sendBytesEncoded = encodeToBase58(sendString);
        recordVariable(logsAndVars, "sendBytesEncoded", sendBytesEncoded);
        // console.log(sendBytesEncoded);
        const signature = await ncSign(provider, walletAddress, sendString);
        recordVariable(logsAndVars, "signature", signature);
        //  console.log(signature);
        const url = baseUrl + sendObject.endpoint;
        recordVariable(logsAndVars, "url", url);
        const params = {
            message: sendBytesEncoded,
            signature: signature,
        };
        recordVariable(logsAndVars, "params", params);
        let responsePromise;
        if (method === "post") {
            responsePromise = axios.post(url, "", { params });
        }
        else if (method === "get") {
            responsePromise = axios.get(url, { params });
        }
        if (responsePromise === undefined) {
            throw new ReportingError("query cannot be started: " + url, logsAndVars);
        }
        //try {
        return (await responsePromise).data;
    }
    catch (error) {
        await recordPotentialAxiosError(logsAndVars, error);
        throw new ReportingError(error, logsAndVars);
    }
    //} catch (error: any) {
    //  const errorString = toErrorString(error);
    //  console.log("error", errorString);
    //  return errorString;
    //}
};
export const sendMessageWithMpcWallet = async (clientSessionToken, userShare, sendObject, responseType, body, forcedBaseUrl) => {
    const logsAndVars = createEmptyLogsAndVars("dwcommonutils:sendMessageWithMpcWallet");
    try {
        recordVariable(logsAndVars, "clientSessionToken (param)", clientSessionToken);
        recordVariable(logsAndVars, "sendObject (param)", sendObject);
        recordVariable(logsAndVars, "responseType (param)", responseType);
        recordVariable(logsAndVars, "body (param)", body);
        recordVariable(logsAndVars, "forcedBaseUrl (param)", forcedBaseUrl);
        const method = decideMethodFromSendObject(sendObject);
        recordVariable(logsAndVars, "method", method);
        const expirationTimestamp = generateExpirationTimeStamp();
        recordVariable(logsAndVars, "expirationTimestamp", expirationTimestamp);
        sendObject.expirationTimestamp = expirationTimestamp;
        const sendString = JSON.stringify(sendObject);
        recordVariable(logsAndVars, "sendString", sendString);
        //  console.log(sendString);
        const sendBytesEncoded = encodeToBase58(sendString);
        recordVariable(logsAndVars, "sendBytesEncoded", sendBytesEncoded);
        // console.log(sendBytesEncoded);
        const signature = await mpcSign(clientSessionToken, userShare, sendString);
        recordVariable(logsAndVars, "signature", signature);
        //  console.log(signature);
        const usedBaseUrl = forcedBaseUrl ?? baseUrl;
        const url = usedBaseUrl + sendObject.endpoint;
        recordVariable(logsAndVars, "url", url);
        const params = {
            message: sendBytesEncoded,
            signature: signature,
        };
        recordVariable(logsAndVars, "params", params);
        const axiosConfig = {
            params,
            responseType: "json",
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
            },
        };
        if (responseType !== undefined) {
            axiosConfig.responseType = responseType;
        }
        let responsePromise;
        if (method === "post") {
            responsePromise = axios.post(url, "", axiosConfig);
        }
        else if (method === "put") {
            responsePromise = axios.put(url, body, axiosConfig);
        }
        else if (method === "delete") {
            responsePromise = axios.delete(url, axiosConfig);
        }
        else if (method === "get") {
            responsePromise = axios.get(url, axiosConfig);
        }
        if (responsePromise === undefined) {
            throw new ReportingError("query cannot be started: " + url, logsAndVars);
        }
        //try {
        const awaitedResponse = await responsePromise;
        recordVariable(logsAndVars, "axios response", awaitedResponse);
        const res = awaitedResponse.data;
        //console.log("sendMessageWithMpcWallet", method, url, params, "result:", JSON.stringify(awaitedResponse));
        return res;
    }
    catch (error) {
        await recordPotentialAxiosError(logsAndVars, error);
        throw new ReportingError(error, logsAndVars);
    }
    //} catch (error: any) {
    //  const errorString = toErrorString(error);
    //  console.log("error", errorString);
    //  return errorString;
    //}
};
/*export const plainWithJWT = async (
  jwt: string,
  method: string,
  endpoint: string,
  responseType?: ResponseType,
  body?: any,
) => {
  const logsAndVars: LogsAndVarsType = createEmptyLogsAndVars("dwcommonutils:sendMessageWithMpcWallet");
  try {
    recordVariable(logsAndVars, "jwt (param)", jwt);
    recordVariable(logsAndVars, "method (param)", method);
    recordVariable(logsAndVars, "endpoint (param)", endpoint);
    recordVariable(logsAndVars, "body (param)", body);

    const url = baseUrl + endpoint;
    recordVariable(logsAndVars, "url", url);
    const axiosConfig: AxiosRequestConfig<string> = {
      responseType: "json",
      headers: {
        Authorization: `Bearer ${jwt}`,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
      },
    };
    if (responseType !== undefined) {
      axiosConfig.responseType = responseType;
    }

    let responsePromise;
    if (method === "post") {
      responsePromise = axios.post(url, body ?? "", axiosConfig);
    } else if (method === "put") {
      responsePromise = axios.put(url, body, axiosConfig);
    } else if (method === "delete") {
      responsePromise = axios.delete(url, axiosConfig);
    } else if (method === "get") {
      responsePromise = axios.get(url, axiosConfig);
    }
    if (responsePromise === undefined) {
      throw new ReportingError("query cannot be started: " + url, logsAndVars);
    }
    //try {
    const awaitedResponse = await responsePromise;
    recordVariable(logsAndVars, "axios response", awaitedResponse);
    const res = awaitedResponse.data;
    //console.log("sendMessageWithMpcWallet", method, url, params, "result:", JSON.stringify(awaitedResponse));
    return res;
  } catch (error: any) {
    await recordPotentialAxiosError(logsAndVars, error);
    throw new ReportingError(error, logsAndVars);
  }
};

export const sendMessageWithJWT = async (
  jwt: string,
  sendObject: any,
  responseType?: ResponseType,
  body?: any,
  forcedBaseUrl?: string,
) => {
  const logsAndVars: LogsAndVarsType = createEmptyLogsAndVars("dwcommonutils:sendMessageWithMpcWallet");
  try {
    recordVariable(logsAndVars, "jwt (param)", jwt);
    recordVariable(logsAndVars, "sendObject (param)", sendObject);
    recordVariable(logsAndVars, "responseType (param)", responseType);
    recordVariable(logsAndVars, "body (param)", body);
    recordVariable(logsAndVars, "forcedBaseUrl (param)", forcedBaseUrl);
    const method = decideMethodFromSendObject(sendObject);
    recordVariable(logsAndVars, "method", method);
    const expirationTimestamp = generateExpirationTimeStamp();
    recordVariable(logsAndVars, "expirationTimestamp", expirationTimestamp);
    sendObject.expirationTimestamp = expirationTimestamp;
    const sendString = JSON.stringify(sendObject);
    recordVariable(logsAndVars, "sendString", sendString);
    //  console.log(sendString);
    const sendBytesEncoded = encodeToBase58(sendString);
    recordVariable(logsAndVars, "sendBytesEncoded", sendBytesEncoded);
    //  console.log(signature);
    const usedBaseUrl = forcedBaseUrl ?? baseUrl;

    const url = usedBaseUrl + sendObject.endpoint;
    recordVariable(logsAndVars, "url", url);
    const params = {
      message: sendBytesEncoded,
    };
    recordVariable(logsAndVars, "params", params);
    const axiosConfig: AxiosRequestConfig<string> = {
      params,
      responseType: "json",
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    };
    if (responseType !== undefined) {
      axiosConfig.responseType = responseType;
    }

    let responsePromise;
    if (method === "post") {
      responsePromise = axios.post(url, body ?? "", axiosConfig);
    } else if (method === "put") {
      responsePromise = axios.put(url, body, axiosConfig);
    } else if (method === "delete") {
      responsePromise = axios.delete(url, axiosConfig);
    } else if (method === "get") {
      responsePromise = axios.get(url, axiosConfig);
    }
    if (responsePromise === undefined) {
      throw new ReportingError("query cannot be started: " + url, logsAndVars);
    }
    //try {
    const awaitedResponse = await responsePromise;
    recordVariable(logsAndVars, "axios response", awaitedResponse);
    const res = awaitedResponse.data;
    //console.log("sendMessageWithMpcWallet", method, url, params, "result:", JSON.stringify(awaitedResponse));
    return res;
  } catch (error: any) {
    await recordPotentialAxiosError(logsAndVars, error);
    throw new ReportingError(error, logsAndVars);
  }
  //} catch (error: any) {
  //  const errorString = toErrorString(error);
  //  console.log("error", errorString);
  //  return errorString;
  //}
};
*/
export const uploadFileWithMpcWallet = async (clientSessionToken, userShare, sendObject, file, forcedBaseUrl) => {
    const logsAndVars = createEmptyLogsAndVars("dwcommontutils:uploadFileWithMpcWallet");
    try {
        recordVariable(logsAndVars, "clientSessionToken (param)", clientSessionToken);
        recordVariable(logsAndVars, "sendObject (param)", sendObject);
        recordVariable(logsAndVars, "file data (param)", file);
        recordVariable(logsAndVars, "forcedBaseUrl (param)", forcedBaseUrl);
        const expirationTimestamp = generateExpirationTimeStamp();
        recordVariable(logsAndVars, "expirationTimestamp", expirationTimestamp);
        sendObject.expirationTimestamp = expirationTimestamp;
        const sendString = JSON.stringify(sendObject);
        recordVariable(logsAndVars, "sendString", sendString);
        //  console.log(sendString);
        const sendBytesEncoded = encodeToBase58(sendString);
        recordVariable(logsAndVars, "sendBytesEncoded", sendBytesEncoded);
        //  console.log(sendBytesEncoded);
        const signature = await mpcSign(clientSessionToken, userShare, sendString);
        recordVariable(logsAndVars, "signature", signature);
        //  console.log(signature);
        const formData = new FormData();
        formData.append("message", sendBytesEncoded);
        formData.append("signature", signature);
        formData.append("file", file);
        const usedBaseUrl = forcedBaseUrl ?? baseUrl;
        const url = usedBaseUrl + sendObject.endpoint;
        recordVariable(logsAndVars, "url", url);
        //try {
        const response = await axios.post(url, formData);
        return response.data;
        //} catch (error: any) {
        //  const errorString = toErrorString(error);
        //  console.log("error", errorString);
        //  return errorString;
        //}
    }
    catch (error) {
        await recordPotentialAxiosError(logsAndVars, error);
        throw new ReportingError(error, logsAndVars);
    }
};
/*export const uploadFileWithJWT = async (
  jwt: string,
  endpoint: string,
  file: File,
  sendObject?: object,
  forcedBaseUrl?: string,
) => {
  const logsAndVars: LogsAndVarsType = createEmptyLogsAndVars("dwcommonutils:uploadFileWithJWT");
  try {
    recordVariable(logsAndVars, "jwt (param)", jwt);
    recordVariable(logsAndVars, "endpoint (param)", endpoint);
    recordVariable(logsAndVars, "file data (param)", file);
    recordVariable(logsAndVars, "forcedBaseUrl (param)", forcedBaseUrl);

    const formData = new FormData();
    if (sendObject !== undefined) {
      const sendString = JSON.stringify(sendObject);
      recordVariable(logsAndVars, "sendString", sendString);
      const sendBytesEncoded = encodeToBase58(sendString);
      recordVariable(logsAndVars, "sendBytesEncoded", sendBytesEncoded);
      formData.append("message", sendBytesEncoded);
    } else {
      collectLog(logsAndVars, "sendObject is undefined");
    }
    formData.append("file", file);

    const usedBaseUrl = forcedBaseUrl ?? baseUrl;

    const url = usedBaseUrl + endpoint;
    recordVariable(logsAndVars, "url", url);
    //try {
    const response = await axios.post(url, formData);
    return response.data;
    //} catch (error: any) {
    //  const errorString = toErrorString(error);
    //  console.log("error", errorString);
    //  return errorString;
    //}
  } catch (error: any) {
    await recordPotentialAxiosError(logsAndVars, error);
    throw new ReportingError(error, logsAndVars);
  }
};
*/
const decideMethodFromSendObject = (sendObject) => {
    if (sendObject?.method === "post") {
        return "post";
    }
    else if (sendObject?.method === "put") {
        return "put";
    }
    else if (sendObject?.method === "delete") {
        return "delete";
    }
    else {
        return "get";
    }
};
export const generateExpirationTimeStamp = () => {
    const currentTimestamp = Math.floor(Date.now() / 1000); // Current UNIX timestamp in seconds
    const expirationTimestamp = currentTimestamp + 600; // Add 600 seconds
    return expirationTimestamp;
};
export const encodeToBase58 = (plainText) => {
    const sendBytes = new TextEncoder().encode(plainText);
    const sendBytesEncoded = bs58.encode(sendBytes);
    return sendBytesEncoded;
};
export const ncSign = async (provider, walletAddress, message) => {
    const hexMessage = toHexString(message);
    const signature = await provider.request({
        method: "personal_sign",
        params: [hexMessage, walletAddress],
    });
    return signature.substring(2);
};
export const mpcSign = async (clientSessionToken, userShare, message) => {
    const logsAndVars = createEmptyLogsAndVars("dwcommontutils:mpcSign");
    recordVariable(logsAndVars, "clientSessionToken (param)", clientSessionToken);
    recordVariable(logsAndVars, "userShare (param)", userShare);
    recordVariable(logsAndVars, "message (param)", message);
    const hexMessage = toHexString(message);
    try {
        //console.log("itt vagyok", hexMessage.substring(2));
        //console.log("itt vagyok2", userShare);
        //console.log("itt vagyok3", clientSessionToken);
        const response = await axios.post("https://mpc-client.portalhq.io/v1/raw/sign/ED25519", {
            param: hexMessage.substring(2),
            share: userShare,
        }, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + clientSessionToken,
            },
        });
        //  console.log("response", response);
        recordVariable(logsAndVars, "response", response);
        return response.data.data;
    }
    catch (error) {
        await recordPotentialAxiosError(logsAndVars, error);
        const errorString = toErrorString(error);
        console.log("error", errorString);
        //dwReportError(null, undefined, error, { logsAndVars, errorMessage: errorString });
        throw new ReportingError(error, logsAndVars);
    }
};
export const bytesToHexString = (bytes) => {
    return Array.from(bytes)
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
};
const toHexString = (message) => {
    return `0x${Buffer.from(message, "utf8").toString("hex")}`;
};
export const fromHexString = (hexString) => {
    // Remove the '0x' prefix if present
    const normalizedHexString = hexString.startsWith("0x") ? hexString.slice(2) : hexString;
    // Check if the string has an even length (required for valid byte representation)
    if (normalizedHexString.length % 2 !== 0) {
        throw new Error("Invalid hex string: length must be even.");
    }
    // Create a Uint8Array to hold the byte values
    const byteArray = new Uint8Array(normalizedHexString.length / 2);
    for (let i = 0; i < byteArray.length; i++) {
        byteArray[i] = parseInt(normalizedHexString.substr(i * 2, 2), 16);
    }
    return byteArray;
};
export const toAsciiString = (data) => {
    return Array.from(data)
        .map((byte) => String.fromCharCode(byte))
        .join("");
};
export const fromAsciiString = (s) => {
    return new Uint8Array([...s].map((char) => char.charCodeAt(0)));
};
const toErrorString = (error) => {
    if (error.response === undefined) {
        return "error";
    }
    else {
        return error.response.status + ": " + JSON.stringify(error.response.data);
    }
};
